var HOME_FEED = "magazine.davinospose.it";


jQuery(document).ready(function(){
	console.log("<-- start home -->");
  	$ = jQuery;
  	$.ajax({
      url: "https://" + HOME_FEED + "/wp-json/wp/v2/posts?per_page=3&_embed",
      type: "GET",
      success:function(result){
        for (i = 0; i < result.length; i++) {
          f=i+1;
          //title
          $("#wpblog_title_"+f).text(result[i]["title"]["rendered"]);
          var wpexcerpt = result[i]["excerpt"]["rendered"];
          //console.log(wpexcerpt);
          //excerpt
          $("#wpblog_excerpt_"+f).text($(wpexcerpt).text());
          //link
          $("#wpblog_link_"+f).attr("href", result[i]["link"]);
          $("#wpblog_link_img_"+f).attr("href", result[i]["link"]);
          $("#wpblog_aimg_"+f).attr("href",result[i]["link"]);
          //image
          try{
          	var wpimg = result[i]["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["medium_large"]["source_url"];
          	$("#wpblog_img_"+f).attr("src",wpimg);
          	$("#wpblog_aimg_"+f).attr("src",wpimg);
          }
          catch(e){
            var wpimg = result[i]["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["medium"]["source_url"];
          	$("#wpblog_img_"+f).attr("src",wpimg);
          	$("#wpblog_aimg_"+f).attr("src",wpimg);
            console.log(e);
          }
          //category
          setWPCategory(result[i]["categories"][0],f);
        }
      },
      error: function(request,state,error){
      	console.log("Chiamata fallita:"+state+" "+error);
      }
    });
});

function setWPCategory(cat,x){
  $.ajax({
    url: "https://" + HOME_FEED + "/wp-json/wp/v2/categories/"+cat ,
    type: "get",
    success:function(result){
      $("#wpblog_cat_"+x).text(result["name"]);
    },
    error: function(){
    }
  });
}